import { render } from "./ResendVerifyEmail.vue?vue&type=template&id=731277b9&scoped=true"
import script from "./ResendVerifyEmail.vue?vue&type=script&lang=js"
export * from "./ResendVerifyEmail.vue?vue&type=script&lang=js"

import "./ResendVerifyEmail.vue?vue&type=style&index=0&id=731277b9&scoped=true&lang=scss"

import exportComponent from "/app/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-731277b9"]])

export default __exports__